module.exports = {
  async getThing(thingId) {
    const url = `${this.url}/${this.version}/things/${thingId}`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/things_api.js